export default "__VITE_PUBLIC_ASSET__7a60df65__"